const HeaderCaptain = ({
  captainImg,
  captainName,
  captainEmail,
  captainPhone,
  subCaptainImg,
  subCaptainName,
  subCaptainEmail,
  subCaptainPhone
}) => {
  return (
    <div className="bg-blue">
      <div className="max-w-6xl flex flex-col lg:flex-row justify-center lg:pb-16 pb-5">
        <div className="mr-24">
          {/* <div className="mt-5 lg:my-10 lg:mr-16">
          <div className="group relative w-28 h-28 lg:w-[250px] lg:h-[250px] rounded-full overflow-hidden bg-sec-grey-1">
            <img src={captainImg} className="object-cover w-full h-full" />
          </div>
          <p className="text-white text-center font-alliance-medium text-[16px] lg:text-[20px] mt-4">
            Capità/na
          </p>
        </div> */}
          <div className="ml-12">
            <div className="text-left">
              <div className="pt-4 leading-tight">
                <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                  Capità/na
                </p>
                <p className="text-white text-3xl lg:text-[32px] leading-tight capitalize">
                  {captainName}
                </p>
              </div>
            </div>
            <div className="">
              <div className="pt-4 leading-tight">
                <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                  Correu
                </p>
                <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
                  {captainEmail}
                </p>
              </div>
              <div className="pt-4 leading-tight">
                <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                  Telèfon:
                </p>
                <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
                  {captainPhone}
                </p>
              </div>
            </div>
          </div>
        </div>
        {subCaptainName && (
          <div className="mt-8 lg:mt-0">
            {/* <div className="mt-5 lg:my-10 lg:mr-16">
            <div className="group relative w-28 h-28 lg:w-[250px] lg:h-[250px] rounded-full overflow-hidden bg-sec-grey-1">
              <img src={subCaptainImg} className="object-cover w-full h-full" />
            </div>
            <p className="text-white text-center font-alliance-medium text-[16px] lg:text-[20px] mt-4">
              Subcapità/na
            </p>
          </div> */}
            <div className="ml-12">
              <div className="text-left">
                <div className="pt-4 leading-tight">
                  <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                    Subcapità/na
                  </p>
                  <p className="text-white text-[32px] leading-tight">
                    {subCaptainName}
                  </p>
                </div>
              </div>
              <div className="">
                <div className="pt-4 leading-tight">
                  <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                    Correu
                  </p>
                  <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
                    {subCaptainEmail}
                  </p>
                </div>
                <div className="pt-4 leading-tight">
                  <p className="text-accent font-alliance-light text-[16px] lg:text-[20px]">
                    Telèfon:
                  </p>
                  <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
                    {subCaptainPhone}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default HeaderCaptain
